import { Routes, RouterModule } from "@angular/router";
import { StructureUsersRootComponent } from "./structure-users-root.component";

const routes: Routes = [
    { path: '', component: StructureUsersRootComponent },
  ];

  export const structureUsersRootRouting = RouterModule.forChild(routes);